// extracted by mini-css-extract-plugin
export default {"timelineWrapper":"Timeline_timelineWrapper__BuqHF"};